import { useState, useEffect } from "react";
import { DARK, PRIORITIES, Spinner } from "./App";

export default function PublicForm() {
  const T = DARK;
  const iS = {width:"100%",background:T.input,border:`1px solid ${T.inputBorder}`,borderRadius:9,padding:"9px 12px",color:T.text,fontSize:13,outline:"none",fontFamily:"inherit"};

  // Get project ID from URL: /form/123
  const projectId = window.location.pathname.split('/form/')[1]?.split('/')[0];
  const [formInfo, setFormInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ title:"", description:"", priority:2, submitter_name:"", submitter_email:"" });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(()=>{
    if (!projectId) { setError("Ungültiger Link"); setLoading(false); return; }
    fetch(`/api/projects/${projectId}/form`)
      .then(r=>r.ok?r.json():r.json().then(e=>{throw new Error(e.error);}))
      .then(d=>{ setFormInfo(d); setLoading(false); })
      .catch(e=>{ setError(e.message); setLoading(false); });
  },[]);

  const submit = async e => {
    e.preventDefault();
    if (!form.title.trim()) return;
    setSubmitting(true);
    try {
      const r = await fetch(`/api/projects/${projectId}/form`, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(form) });
      if (!r.ok) { const err=await r.json(); throw new Error(err.error); }
      setSent(true);
    } catch(err) { setError(err.message); }
    finally { setSubmitting(false); }
  };

  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
    *{box-sizing:border-box;margin:0;padding:0}
    body{background:#080810;font-family:'DM Sans','Segoe UI',sans-serif}
    @keyframes fadeUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}
    @keyframes spin{to{transform:rotate(360deg)}}
    input::placeholder,textarea::placeholder{color:#3A3A56}
  `;

  if (loading) return <>
    <style>{styles}</style>
    <div style={{minHeight:"100vh",background:"#080810",display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{width:36,height:36,border:"3px solid #252538",borderTop:"3px solid #6366F1",borderRadius:"50%",animation:"spin 0.8s linear infinite"}}/>
    </div>
  </>;

  if (error) return <>
    <style>{styles}</style>
    <div style={{minHeight:"100vh",background:"#080810",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{textAlign:"center",color:"#E2E2EE"}}>
        <div style={{fontSize:52,marginBottom:16}}>⚠</div>
        <div style={{fontSize:18,fontWeight:600,marginBottom:8}}>Formular nicht verfügbar</div>
        <div style={{fontSize:14,color:"#5A5A7A"}}>{error}</div>
      </div>
    </div>
  </>;

  if (sent) return <>
    <style>{styles}</style>
    <div style={{minHeight:"100vh",background:"#080810",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{textAlign:"center",color:"#E2E2EE",animation:"fadeUp 0.4s ease"}}>
        <div style={{fontSize:64,marginBottom:20}}>✅</div>
        <div style={{fontSize:22,fontWeight:700,marginBottom:8}}>Eingereicht!</div>
        <div style={{fontSize:14,color:"#5A5A7A",marginBottom:24}}>Deine Anfrage wurde erfolgreich übermittelt.</div>
        <button onClick={()=>{setSent(false);setForm({title:"",description:"",priority:2,submitter_name:"",submitter_email:""});}} style={{background:"#6366F1",border:"none",color:"#fff",padding:"11px 24px",borderRadius:10,fontSize:14,fontWeight:600,cursor:"pointer"}}>Weitere Anfrage einreichen</button>
      </div>
    </div>
  </>;

  const { project, form: formConfig } = formInfo;

  return <>
    <style>{styles}</style>
    <div style={{minHeight:"100vh",background:"#080810",padding:"40px 20px",display:"flex",justifyContent:"center"}}>
      <div style={{width:"100%",maxWidth:540,animation:"fadeUp 0.4s ease"}}>
        {/* Header */}
        <div style={{textAlign:"center",marginBottom:32}}>
          <div style={{width:56,height:56,borderRadius:16,background:project.color+"22",display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,margin:"0 auto 12px"}}>{project.icon}</div>
          <div style={{fontSize:22,fontWeight:700,color:"#E2E2EE",marginBottom:6}}>{formConfig.title||project.name}</div>
          {formConfig.description&&<div style={{fontSize:14,color:"#5A5A7A",lineHeight:1.6}}>{formConfig.description}</div>}
        </div>
        {/* Form */}
        <div style={{background:"#0A0A14",border:"1px solid #1A1A2C",borderRadius:18,padding:32}}>
          {error&&<div style={{background:"#FF475718",border:"1px solid #FF475740",borderRadius:10,padding:"10px 14px",color:"#FF4757",fontSize:13,marginBottom:16}}>⚠ {error}</div>}
          <form onSubmit={submit} style={{display:"flex",flexDirection:"column",gap:16}}>
            <div>
              <div style={{fontSize:10,color:"#3A3A56",fontWeight:700,letterSpacing:"0.1em",marginBottom:7}}>TITEL *</div>
              <input value={form.title} onChange={e=>setForm(f=>({...f,title:e.target.value}))} placeholder="Kurze Zusammenfassung…" style={iS} required autoFocus/>
            </div>
            {formConfig.allow_description&&<div>
              <div style={{fontSize:10,color:"#3A3A56",fontWeight:700,letterSpacing:"0.1em",marginBottom:7}}>BESCHREIBUNG</div>
              <textarea value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} placeholder="Details, Schritte, Kontext…" rows={4} style={{...iS,resize:"vertical"}}/>
            </div>}
            {formConfig.allow_priority&&<div>
              <div style={{fontSize:10,color:"#3A3A56",fontWeight:700,letterSpacing:"0.1em",marginBottom:7}}>PRIORITÄT</div>
              <div style={{display:"flex",gap:8}}>
                {PRIORITIES.map((p,i)=><div key={i} onClick={()=>setForm(f=>({...f,priority:i}))} style={{flex:1,padding:"9px 6px",borderRadius:9,cursor:"pointer",textAlign:"center",background:form.priority===i?p.bg:"#0F0F1C",border:`1px solid ${form.priority===i?p.color+"60":"#1E1E30"}`,fontSize:11,fontWeight:600,color:form.priority===i?p.color:"#5A5A7A",transition:"all 0.15s"}}>{p.label}</div>)}
              </div>
            </div>}
            <div style={{borderTop:"1px solid #14142A",paddingTop:16}}>
              <div style={{fontSize:10,color:"#3A3A56",fontWeight:700,letterSpacing:"0.1em",marginBottom:12}}>DEINE KONTAKTDATEN (optional)</div>
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                <input value={form.submitter_name} onChange={e=>setForm(f=>({...f,submitter_name:e.target.value}))} placeholder="Dein Name" style={iS}/>
                <input type="email" value={form.submitter_email} onChange={e=>setForm(f=>({...f,submitter_email:e.target.value}))} placeholder="Deine E-Mail" style={iS} required={formConfig.require_email}/>
              </div>
            </div>
            <button type="submit" disabled={submitting||!form.title.trim()} style={{background:"linear-gradient(135deg,#6366F1,#8B5CF6)",border:"none",color:"#fff",padding:"13px",borderRadius:11,fontSize:14,fontWeight:600,cursor:"pointer",opacity:(submitting||!form.title.trim())?0.6:1,marginTop:4}}>{submitting?<Spinner/>:"Anfrage einreichen →"}</button>
          </form>
        </div>
        <div style={{textAlign:"center",marginTop:20,fontSize:12,color:"#2A2A40"}}>Powered by TaskFlow</div>
      </div>
    </div>
  </>;
}
